(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    // Gestion du message slide-in pour l'inscription email
  document.addEventListener('DOMContentLoaded', function() {
    // Trouver tous les messages d'inscription email
    const emailSignupMessages = document.querySelectorAll('.email-signup__message');

    emailSignupMessages.forEach(message => {
      // Ajouter la classe pour l'auto-hide après 4 secondes
      message.classList.add('email-signup__message--auto-hide');

      // Optionnel: permettre la fermeture manuelle en cliquant sur le message
      message.addEventListener('click', function() {
        message.classList.add('email-signup__message--exiting');
        setTimeout(() => {
          message.remove();
        }, 200);
      });

      // Fermer avec la touche Escape
      message.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          message.classList.add('email-signup__message--exiting');
          setTimeout(() => {
            message.remove();
          }, 200);
        }
      });

      // Rendre le message focusable pour l'accessibilité
      message.setAttribute('tabindex', '0');
      message.setAttribute('role', 'alert');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // Cocher automatiquement le filtre "en stock" par défaut (une seule fois)
  (function() {
    let hasAutoChecked = false;
    const STORAGE_KEY = 'inStockFilterAutoChecked';

    function autoCheckInStockFilter() {
      // Ne s'exécuter qu'une seule fois par session et seulement si aucun filtre n'est déjà actif dans l'URL
      if (hasAutoChecked) return;

      // Vérifier si un filtre est déjà actif dans l'URL
      const urlParams = new URLSearchParams(window.location.search);
      const hasActiveFilters = Array.from(urlParams.keys()).some(key =>
        key.startsWith('filter.') && key !== 'filter.v.price.gte' && key !== 'filter.v.price.lte'
      );

      // Si des filtres sont déjà actifs, ne pas forcer le filtre "en stock"
      if (hasActiveFilters) {
        hasAutoChecked = true;
        return;
      }

      // Vérifier dans sessionStorage si on a déjà coché ce filtre
      const alreadyChecked = sessionStorage.getItem(STORAGE_KEY);
      if (alreadyChecked === 'true') {
        hasAutoChecked = true;
        return;
      }

      // Attendre un peu pour que les filtres soient complètement chargés
      setTimeout(() => {
        // Chercher tous les filtres de type boolean (disponibilité)
        const allFilters = document.querySelectorAll('facet-inputs-component');

        for (const filterComponent of allFilters) {
          // Chercher le label du filtre pour identifier le filtre de disponibilité
          const filterLabel = filterComponent.closest('details')?.querySelector('.facets__label');
          const labelText = filterLabel?.textContent?.toLowerCase() || '';

          // Vérifier si c'est un filtre de disponibilité
          const isAvailabilityFilter =
            labelText.includes('disponibilité') ||
            labelText.includes('availability') ||
            labelText.includes('stock') ||
            labelText.includes('en stock');

          if (isAvailabilityFilter) {
            // Chercher l'input correspondant à "en stock"
            const inputs = filterComponent.querySelectorAll('input[type="checkbox"]:not(:disabled)');

            for (const input of inputs) {
              const label = input.closest('li')?.querySelector('label');
              const inputLabelText = label?.textContent?.toLowerCase() || '';

              // Vérifier si c'est l'option "en stock"
              const isInStock =
                inputLabelText.includes('en stock') ||
                inputLabelText.includes('available') ||
                inputLabelText.includes('disponible') ||
                (input.value === '1' && !inputLabelText.includes('épuisé') && !inputLabelText.includes('out of stock'));

              if (isInStock && !input.checked) {
                // Cocher l'input
                input.checked = true;

                // Marquer comme déjà coché dans sessionStorage
                sessionStorage.setItem(STORAGE_KEY, 'true');
                hasAutoChecked = true;

                // Déclencher la mise à jour des filtres
                if (typeof filterComponent.updateFilters === 'function') {
                  filterComponent.updateFilters();
                }

                // Sortir après avoir coché le premier filtre "en stock" trouvé
                return;
              }
            }
          }
        }

        // Si aucun filtre "en stock" n'a été trouvé, marquer comme traité pour éviter de réessayer
        hasAutoChecked = true;
      }, 100);
    }

    // Exécuter au chargement du DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoCheckInStockFilter);
    } else {
      autoCheckInStockFilter();
    }

    // Ré-exécuter seulement après le rendu de la section dans l'éditeur (pas après les mises à jour de filtres)
    document.addEventListener('shopify:section:load', () => {
      hasAutoChecked = false;
      sessionStorage.removeItem(STORAGE_KEY);
      autoCheckInStockFilter();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["redirection-hm"] && !Shopify.designMode) return;
  try {
    // Gestion des clics sur le bouton de redirection HM
  document.addEventListener('DOMContentLoaded', function() {
    const redirectionButtons = document.querySelectorAll('.redirection-hm-button');
    
    redirectionButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        // Ajouter une classe de chargement
        this.classList.add('loading');
        
        // Optionnel: tracker l'événement
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {
            event_category: 'Redirection',
            event_label: 'HM',
            value: this.href
          });
        }
        
        // Optionnel: délai pour l'animation
        setTimeout(() => {
          this.classList.remove('loading');
        }, 1000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
